import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { RootState } from '.'

export type Category = {
  id: string
  label: string
}

export type CategoryState = {
  categories: Category[]
}

export const categoryState: CategoryState = {
  categories: [],
}

export const categorySlice = createSlice({
  name: 'category',
  initialState: categoryState,
  reducers: {
    setCategories: (state, action: PayloadAction<CategoryState>) => {
      return action.payload
    },
    addCategory: (state, action: PayloadAction<Category>) => {
      state.categories.push(action.payload)
    },
  },
})

export const { addCategory, setCategories } = categorySlice.actions

export const selectCategories = (state: RootState): CategoryState => state[categorySlice.name]

export default categorySlice.reducer
